export const LAST_CLINIC_ID = 'lastClinicId';
